export default __webpack_public_path__ + "static/media/145.cfce6f4d.jpg";